export default __webpack_public_path__ + "static/media/phone-email.3a2a1ef4.svg";